import React from 'react';

export class KiteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log the error to a server-side error tracking tool
    console.log(error);
  }

  render() {
    if (this.state.hasError) {
      // Show a user-friendly error message
      return <p>An error has occurred. Please try again later.</p>;
    }

    // Render the wrapped component
    return this.props.children;
  }
}
